<template>
  <div class="applicateMap">
    <div class="headTitle">
      <div class="shadowTxt">ADDRESS</div>
      <div class="title">联系我们</div>
    </div>
    <div class="address">
      <p>
        地址：北京市丰台区广安路9号国投财富广场2号楼18层
        <br />联系电话：010-6336 6673
      </p>
    </div>
    <div class="mapPart">
      <ul class="city">
        <li v-for="item in cities" :key="item.id" @click="goMap(item)">
          {{ item.city }}
        </li>
      </ul>
      <div class="map" id="map" style="height: 300px"></div>
    </div>
  </div>
</template>

<script>
import { apiGetCities } from "../../api/index";

export default {
  name: "relation",
  metaInfo: {
      title: '联系我们-爱情地产',
      meta: [{
      name: 'keyWords',
      content: '爱情地产'
      },
      {
      name: 'description',
      content: ''
      }]
  },
  data() {
    return {
      cities: [],
    };
  },
  methods: {
    goMap(val) {
      var map = new BMapGL.Map("map"); // 创建地图实例
      var point = new BMapGL.Point(val.coordx, val.coordy); // 创建点坐标
      var marker = new BMapGL.Marker(point); // 创建标注
      if (val.city == "北京") map.addOverlay(marker);
      map.centerAndZoom(point, 15);
    },
  },
  mounted() {
    apiGetCities().then((data) => {
      if (data.data.status == 1) {
        this.cities = data.data.relation;
        this.goMap(this.cities[0]);
      }
    });
  },
};
</script>

<style scoped lang='less'>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
img {
  width: 100%;
}
.headTitle {
  padding: 20px 15px 7px 15px;
  background: #fff;
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
  }
}
.address {
  padding: 0 15px;
  color: #666;
  font-size: 13px;
  line-height: 20px;
}
.mapPart {
  .city {
    padding: 6px 17px 14px 23px;
    font-size: 13px;
    line-height: 18px;
    color: #666666;
    box-shadow: 0 -10px 16px 2px #f8f8f8;
    background: #fff;
    overflow: hidden;
    border-radius: 5px;
    margin: 15px 15px 0;
    position: relative;
    li {
      margin-right: 35px;
      margin-bottom: 10px;
      float: left;
    }
  }
}
</style>